import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useRealtimeParticipants } from '../../hooks/useRealtime'
import { BestLapOverlay } from '../../components/overlay/BestLapOverlay'

export function BestLapPage() {
  const [searchParams] = useSearchParams()
  const raceId = searchParams.get('race') || ''
  const [bestLapParticipant, setBestLapParticipant] = useState<any>(null)

  const { participants } = useRealtimeParticipants(raceId)

  useEffect(() => {
    if (participants.length === 0) return

    const best = participants.reduce((prev, current) => {
      const prevBest = prev.best_lap_time || Infinity
      const currentBest = current.best_lap_time || Infinity
      return currentBest < prevBest ? current : prev
    })

    setBestLapParticipant(best)
  }, [participants])

  if (!bestLapParticipant) {
    return (
      <div className="w-full h-screen bg-transparent flex items-center justify-center">
        <div className="text-center text-gray-400 font-quicksand">
          <p className="text-xl">No best lap yet</p>
        </div>
      </div>
    )
  }

  return (
    <div className="w-full h-screen bg-transparent">
      <BestLapOverlay
        pilotName={bestLapParticipant.pilot_name}
        boatNumber={bestLapParticipant.boat_number}
        boatColor={bestLapParticipant.boat_color}
        lapTime={bestLapParticipant.best_lap_time}
      />
    </div>
  )
}
